/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";

const ellipsisWrapperStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: end;
  width: fit-content;
`;

const dropdownWrapperStyle = css`
  display: flex;
  align-items: end;
  flex-direction: row;
  border: none;
  gap: 8px;
  border-top: none;
  justify-content: end;
`;

interface Props
  extends React.DetailedHTMLProps<
    React.TdHTMLAttributes<HTMLTableCellElement>,
    HTMLTableCellElement
  > {
  children: React.ReactNode;
}

export const TableEllipsisWrapper = ({ children, ...rest }: Props) => {
  return (
    <td css={dropdownWrapperStyle} {...rest}>
      <div css={ellipsisWrapperStyle}>{children}</div>
    </td>
  );
};
